import React from "react";
import { useGlobalUtils } from "../../../../lib/globalUtils";
import { useTranslation } from "react-i18next";

const OrderCardSimple = ({ order, onViewDetails }) => {
  const { t } = useTranslation("orders");
  const { parsePrice, parseDate } = useGlobalUtils();

  // Extract order information
  const orderId = order?.id || "N/A";
  const totalPrice = order?.summary?.total || order?.total || 0;
  const orderDate = order?.created_at || order?.timestamp || new Date();

  // Get order items description
  const getOrderItemsDescription = (order) => {
    if (!order?.products || order.products.length === 0) {
      return t("cardSimple.noItems");
    }

    return order.products
      .map((product) => `${product.quantity}x ${product.name}`)
      .join(", ");
  };

  const itemsDescription = getOrderItemsDescription(order);

  return (
    <div
      className="hover:bg-gray-750 cursor-pointer rounded-lg border border-gray-700 bg-gray-800 p-4 transition-colors"
      onClick={() => onViewDetails && onViewDetails(order)}
    >
      {/* Header Row */}
      <div className="mb-2 flex items-start justify-between">
        {/* Order ID */}
        <div className="flex-1">
          <h3 className="text-lg font-bold text-white">
            {t("card.orderNumber", { id: orderId })}
          </h3>
        </div>

        {/* Price and Date */}
        <div className="text-right">
          <div className="text-lg font-bold text-green-400">
            {parsePrice(totalPrice)}
          </div>
          <div className="text-sm text-gray-400">{parseDate(orderDate)}</div>
        </div>
      </div>

      {/* Items Description */}
      <div className="text-sm text-gray-300">{itemsDescription}</div>
    </div>
  );
};

export default OrderCardSimple;
